import api from '@pray/shared/utils/api';

import type { SeedRunListEnvelope, SeedRunMetricsState, SeedRunStatus, SeedRunType } from './types';

const RUNS_URL = '/web/studio/admin/seed-emails/runs';

export type GetRunsParams = {
  /** Matches the campaign name or the tracking header value. */
  q?: string;
  type?: SeedRunType | '';
  status?: SeedRunStatus | '';
  metricsState?: SeedRunMetricsState | '';
  sortColumn?: 'started_at' | 'inbox_rate';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
};

/**
 * The Runs list, its unfiltered stats and its facet counts in one call.
 *
 * A row never carries the rendered body nor the placement report: the five counters of
 * `report_summary` are what the Inbox column reads, and the detail is what carries the rest.
 */
export async function getRuns({
  q,
  type,
  status,
  metricsState,
  sortColumn = 'started_at',
  sortDirection = 'desc',
  limit = 15,
  offset = 0,
}: GetRunsParams = {}) {
  const params: Record<string, string | number> = {
    sort_column: sortColumn,
    sort_direction: sortDirection,
    limit,
    offset,
  };
  // An empty filter is left out entirely: the schema takes a valid value or refuses the request,
  // and `type=` is not a run type.
  if (q) params.q = q;
  if (type) params.type = type;
  if (status) params.status = status;
  if (metricsState) params.metrics_state = metricsState;

  const res = await api.executeGetRequest<SeedRunListEnvelope>(RUNS_URL, params);
  return res.data;
}
